/**
 * How to render dynamic template fields in forms (Lead / Student document generation).
 */

/** ISO yyyy-mm-dd → dd-mm-yyyy for display in template forms. */
export function isoDateToDdMmYyyy(iso) {
  if (iso == null || iso === '') return '';
  const s = String(iso).trim();
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  if (/^\d{2}-\d{2}-\d{4}$/.test(s)) return s;
  return '';
}

/** Parse dd-mm-yyyy → ISO yyyy-mm-dd (empty string if invalid). */
export function ddMmYyyyToIso(ddmm) {
  const m = String(ddmm || '')
    .trim()
    .match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (!m) return '';
  const d = Number(m[1]);
  const mo = Number(m[2]);
  const y = Number(m[3]);
  if (mo < 1 || mo > 12 || d < 1 || d > 31) return '';
  const dt = new Date(Date.UTC(y, mo - 1, d));
  if (dt.getUTCFullYear() !== y || dt.getUTCMonth() !== mo - 1 || dt.getUTCDate() !== d) return '';
  return `${y}-${String(mo).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
}

/** Normalise API / auto-fill value to yyyy-mm-dd for the date picker and generate API. */
export function normalizeTemplateDateValueForIso(raw) {
  const s = String(raw || '').trim();
  if (!s) return '';
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  return ddMmYyyyToIso(s);
}

export function getTemplateFieldInputKind(fieldKey) {
  const k = String(fieldKey || '')
    .toLowerCase()
    .replace(/\s+/g, '_');

  if (
    k === 'agreement_date' ||
    k === 'date_of_agreement' ||
    k.endsWith('_agreement_date') ||
    (k.includes('agreement') && k.includes('date') && !k.includes('address'))
  ) {
    return 'date';
  }

  if (
    k === 'dob' ||
    k === 'date_of_birth' ||
    k === 'do_b' ||
    k === 'date' ||
    k === 'letter_date' ||
    k === 'current_date' ||
    k === 'today' ||
    k === 'last_date' ||
    k.endsWith('_last_date') ||
    (k.includes('last') && k.includes('date'))
  ) {
    return 'date';
  }

  if (
    k.includes('address') ||
    k.includes('remarks') ||
    k.includes('description')
  ) {
    return 'textarea';
  }

  return 'text';
}
